

export const isDev = false
export function vuetifyConfiguration() {
  const options = JSON.parse('{"theme":{"defaultTheme":"cccfpdTheme","themes":{"cccfpdTheme":{"dark":false,"colors":{"primary":"#6295e1","secondary":"#908984","poppyRed":"#B3261E","danger":"#e04c1f","error":"#e04c1f","success":"#7ba859"}}}},"defaults":{"VSelect":{"variant":"solo","class":"portal-field"},"VTextField":{"variant":"solo","class":"portal-field"},"VTextarea":{"variant":"solo","class":"portal-field"},"VAutocomplete":{"variant":"solo","class":"portal-field"},"VCombobox":{"variant":"solo","class":"portal-field"},"VRadioGroup":{"class":"portal-field"},"VBtn":{"elevation":0}}}')
  
  
  
  
  return options
}

